/**
 * Tiny localStorage cache for the right-drawer panels (Todoist Today, Shipments). Enables a
 * hydrate-then-refresh feel: paint the last-known data instantly when a panel opens, then refresh
 * from the server in the background. Namespaced per user so accounts never see each other's data;
 * cleared on sign-out alongside the note index (see clearLocalData in App.tsx — same `lapo-` prefix).
 */
const PREFIX = 'lapo-panel-';

export function panelCacheKey(name: string, uid: string | undefined): string {
  return `${PREFIX}${name}:${uid ?? 'local'}`;
}

export function readPanelCache<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writePanelCache<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota / private mode — the cache is best-effort */
  }
}
